module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('b', [_c('i', [_vm._v("Contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292747388_07_in"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292747388_08_ch1"
    }
  }, [_vm._v("Mesquite: What Is It?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292747388_09_ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Predators of Mesquite")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292747388_10_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mesquite in Texas and the Southwestern United States")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292747388_11_ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Uses of Mesquite")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292747388_12_ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mesquite in Verse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292747388_13_ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Worldwide Aspects of "), _c('i', [_vm._v("Prosopis")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292747388_14_ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Texas Ebony—Mesquite’s Astonishing Cousin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292747388_15_ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mesquite’s Future")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292747388_16_app1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 1. The Genus "), _c('i', [_vm._v("Prosopis")]), _vm._v(" (Family Leguminosae/Fabaceae) and Its Species")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292747388_17_app2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 2. Sources of Information")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292747388_18_ref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References and Further Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292747388_19_index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p')])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e416b3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780292747388_06_toc.vue
// module id = 72
// module chunks = 0